// extracted by mini-css-extract-plugin
export default {"pay-component":"e8k_l_pay-component"};